import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import Ionicons from '@expo/vector-icons/Ionicons';
import { useTheme } from '../theme/ThemeContext';
import { useTranslation } from '../i18n/I18nContext';

export function proofDate(value: unknown, lang: string): string | null {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const date = new Date(value + 'T00:00:00Z');
  if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== value) return null;
  return date.toLocaleDateString(lang, { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' });
}
export default function ProfileContactProof({ sms, google }: { sms?: string | null; google?: string | null }) {
  const { t, lang } = useTranslation();
  const colors = useTheme();
  const smsDate = proofDate(sms, lang), googleDate = proofDate(google, lang);
  if (!smsDate && !googleDate) return null;
  return <View testID="profile-contact-proof" style={styles.section}>
    {smsDate && <View style={styles.row}>
      <Ionicons name="chatbox-ellipses-outline" size={18} color={colors.gray600} accessible={false} />
      <Text style={[styles.text, { color: colors.gray600 }]}>{t('userProfile.smsVerifiedOn', { date: smsDate })}</Text>
    </View>}
    {googleDate && <Text style={[styles.text, { color: colors.gray600 }]}>{t('userProfile.googleLinkedOn', { date: googleDate })}</Text>}
    <Text style={[styles.note, { color: colors.gray600 }]}>{t('userProfile.contactProofNote')}</Text>
  </View>;
}
const styles = StyleSheet.create({
  section: { marginTop: 12, gap: 6 },
  row: { flexDirection: 'row', alignItems: 'flex-start', gap: 6 },
  text: { fontSize: 13, flexShrink: 1 },
  note: { fontSize: 12, lineHeight: 17 },
});
